<template>
    <div>
        <slot name="title">
            <h3>{{$t('common.address')}}</h3>
        </slot>
        <el-form-item :label="$t('common.companyName')"
                      prop="shipToName">
            <el-input v-model="value.shipToName"
                      v-if="!showAsPreview"
                      :disabled="disable"></el-input>
            <span v-if="showAsPreview">{{value.shipToName}}</span>
        </el-form-item>
        <el-form-item :label="$t('common.address')"
                      prop="address">
            <el-input v-model="value.address"
                      v-if="!showAsPreview"
                      :disabled="disable"
                      autoComplete="new-password"></el-input>
            <span v-if="showAsPreview">{{value.address}}</span>
        </el-form-item>
        <el-form-item :label="$t('shared.countryProvince')"
                      prop="selectedCountryState">
            <el-cascader v-model="value.selectedCountryState"
                         :disabled="disable"
                         class="selector"
                         :placeholder="$t('shared.selectCountryAndProvince')"
                         :options="countriesWithStates"
                         filterable
                         change-on-select
                         v-if="!showAsPreview"></el-cascader>
            <span v-if="showAsPreview">{{selectedCountryState}}</span>
        </el-form-item>
        <el-form-item :label="$t('common.city')"
                      prop="city">
            <el-input v-model="value.city"
                      v-if="!showAsPreview"
                      :disabled="disable"
                      autoComplete="new-password"></el-input>
            <span v-if="showAsPreview">{{value.city}}</span>
        </el-form-item>
        <el-form-item
      :label="$t('common.regional')"
      prop="regional"
      v-if="showRegional"
      :disabled="disable"
    >
      <el-input
        v-model="value.regional"
        v-if="!showAsPreview"
        autoComplete="new-password"
      ></el-input>
      <span v-if="showAsPreview">{{value.regional}}</span>
    </el-form-item>
        <el-form-item :label="$t('common.region')"
                      prop="region"
                      v-if="showRegional"
                      :disabled="disable">
            <el-input v-model="value.region"
                      v-if="!showAsPreview"
                      autoComplete="new-password"></el-input>
            <span v-if="showAsPreview">{{value.region}}</span>
        </el-form-item>
        <el-form-item :label="$t('shared.zip')"
                      prop="zip">
            <el-input v-model="value.zip"
                      v-if="!showAsPreview"
                      :disabled="disable"
                      autoComplete="new-password"></el-input>
            <span v-if="showAsPreview">{{value.zip}}</span>
        </el-form-item>
    </div>
</template>

<script>
    import api from "./api";
    import { EventBus } from "@/app/event-bus.js";
    export default {
        name: "address-selector",
        props: {
            value: Object,
            showRegional: {
                type: Boolean,
                default: false
            },
            showAsPreview: {
                type: Boolean,
                default: false
            },
            disable: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            value: {
                deep: true,
                handler: function (val) {
                    this.$emit("input", val);
                }
            }
        },
        data() {
            return {
                countriesWithStates: []
            };
        },
        created() {
            api.getCountries().then(response => {
                this.countriesWithStates = response.data;
            });
        },
        mounted() {
            EventBus.$on("countryCreated", id => {
                api.getCountries().then(response => {
                    this.countriesWithStates = response.data;
                });
            });
        },
        computed: {
            selectedCountryState() {
                let result = "";
                if (
                    this.value &&
                    this.value.selectedCountryState &&
                    this.value.selectedCountryState[0]
                ) {
                    this.countriesWithStates.forEach(x => {
                        if (x.value === this.value.selectedCountryState[0]) {
                            result = x.label;
                            if (this.value.selectedCountryState[1]) {
                                x.children.forEach(c => {
                                    if (c.value === this.value.selectedCountryState[1]) {
                                        result = result + " / " + c.label;
                                    }
                                });
                            }
                        }
                    });
                }
                return result;
            }
        }
    };
</script>

<style scoped>
    .selector {
        width: 100%;
    }
</style>



// WEBPACK FOOTER //
// ClientApp/app/shared/components/addressselector/AddressSelector.vue